import React from "react";
import { FormControlLabel, RadioGroup } from "@mui/material";

export interface PRadioGroupProps<A extends string> {
  options: A[];
  value: A;
  onChange: (a: A) => void;
  renderOption?: (a: A) => string;
  control: React.ReactElement<any, any>;
  row?: boolean;
}

export function PRadioGroup<A extends string>(props: PRadioGroupProps<A>): React.ReactElement {
  const renderOption = props.renderOption ? props.renderOption : (opt: A) => opt;
  return (
    <RadioGroup row={props.row} value={props.value} onChange={(evt) => props.onChange(evt.target.value as A)}>
      {props.options.map((opt) => (
        <FormControlLabel key={opt} control={props.control} label={renderOption(opt)} value={opt} />
      ))}
    </RadioGroup>
  );
}

export default PRadioGroup;
